import { api } from '../../services/api';
import * as types from '../Constants';

export const getClientProfileReport = (id, familyId) => {
  const options = {
    url: `v1/profilereport/client/${id}/${familyId}`,
  };
  options.types = [
    types.GET_CLIENT_PROFILE_REPORT_SUCCESS,
    types.GET_CLIENT_PROFILE_REPORT_FAILURE,
  ];
  return api.getFile(options);
};

export const getPotentialClientProfileReport = (id) => {
  const options = {
    url: `v1/profilereport/potentialclient/${id}`,
  };
  options.types = [
    types.GET_POTENTIAL_CLIENT_PROFILE_REPORT_SUCCESS,
    types.GET_POTENTIAL_CLIENT_PROFILE_REPORT_FAILURE,
  ];
  return api.getFile(options);
};

export const getEmployerProfileReport = (id) => {
  const options = {
    url: `v1/profilereport/employer/${id}`,
  };
  options.types = [
    types.GET_EMPLOYER_PROFILE_REPORT_SUCCESS,
    types.GET_EMPLOYER_PROFILE_REPORT_FAILURE,
  ];
  return api.getFile(options);
};
